import { Box, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { Loader } from "../genericComponents/MainLoader/Loader";
import { Address, ResponseObject, ServiceRequest } from "@/app/classes/main";
import { cities } from "./footerCityData.js";
import { ApiService } from "@/app/services/AppService";
import { getToken } from "@/app/services/HolderService";
import Cookies from "js-cookie";

export const FooterCityList = () => {
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState<Address>();
  const [location, setLocation] = useState<{
    latitude: number | string | null;
    longitude: number | string | null;
  }>({
    latitude: null,
    longitude: null,
  });
  const apiService: ApiService = useMemo(() => new ApiService(), []);

  useEffect(() => {
    if (location.latitude != null && location.longitude != null) {
      // console.log("location" + JSON.stringify(location));
      const serviceRequest: ServiceRequest = new ServiceRequest();
      serviceRequest.latitude = Number.parseFloat(
        location?.latitude.toString()
      );
      serviceRequest.longitude = Number.parseFloat(
        location.longitude.toString()
      );
      apiService
        .post(apiService.checkAvailability, serviceRequest, getToken()!)
        .then((value: unknown) => {
          const res = value as ResponseObject;
          if (res.status == "success" && res.object != null) {
            setLoading(true);
            localStorage.setItem(
              "serviceHub",
              btoa(JSON.stringify(res?.object))
            );
            localStorage.setItem(
              "serviceHubSlug",
              btoa(JSON.stringify(res?.object?.slug))
            );
            localStorage.setItem("address", btoa(JSON.stringify(address)));
            Cookies.set("serviceHub", res?.object?.id, {
              expires: 365,
              secure: true,
              sameSite: "Strict", // or 'Lax', depending on your use case
            });
            Cookies.set("serviceHubSlug", res?.object?.slug, {
              expires: 365,
              secure: true,
              sameSite: "Strict", // or 'Lax', depending on your use case
            });
            window.location.reload();
          } else {
            alert(
              "Opps! We are not available at this location now. Please choose another location."
            );
            setLoading(false);
          }
        });
    }
  }, [location]);

  const handleLocationByFooter = (place_id: any) => {
    setLoading(true);
    if (!place_id) return;
    const placesService = new google.maps.places.PlacesService(
      document.createElement("div")
    );
    placesService?.getDetails(
      { placeId: place_id },
      (placeDetails: google.maps.places.PlaceResult | null) => {
        if (placeDetails) {
          const address: Address = new Address();
          address.placeId = place_id;
          address.formattedAddress = placeDetails?.formatted_address;
          address.savedAddress = false;
          address.latitude = placeDetails?.geometry?.location?.lat();
          address.longitude = placeDetails?.geometry?.location?.lng();
          setAddress(address);
          // localStorage.setItem("address", btoa(JSON.stringify(address)));
          setLocation({
            latitude: placeDetails?.geometry?.location?.lat() ?? null,
            longitude: placeDetails?.geometry?.location?.lng() ?? null,
          });
        }
      }
    );
  };

  return (
    <>
      {loading && <Loader />}
      <Box
        sx={{
          display: "contents",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        {cities &&
          cities
            ?.sort((a, b) => a.name.localeCompare(b.name))
            .map((item, index) => (
              <Typography
                key={index}
                sx={{ cursor: "pointer", textWrap: "nowrap" }}
                onClick={() => handleLocationByFooter(item.placeId)}
              >
                {item.name}
                {index !== cities.length - 1 && <>&nbsp;|&nbsp;</>}
              </Typography>
            ))}
      </Box>
    </>
  );
};
